// extracted by mini-css-extract-plugin
export default {"rateCandidate":"RateCandidate_rateCandidate__yoF5s","yellowStarIcon":"RateCandidate_yellowStarIcon__fbVZm","grayStarIcon":"RateCandidate_grayStarIcon__sn3kl"};